module.exports = function() {
  return new Worker(__webpack_public_path__ + "24dd517a31ecf51735db.worker.js");
};